import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { request } from "../../../api/http";
import { GhostButton, ModalShell } from "../../../components/FormControls";
import {
  CouponLead,
  CouponLeadsResponse,
  PromoDto,
  fmtDate,
} from "../../../types/promos";
import { describeError } from "./CreateCouponModal";

type Props = {
  token: string | null;
  coupon: PromoDto;
  onClose: () => void;
};

export default function CouponLeadsModal({ token, coupon, onClose }: Props) {
  const [leads, setLeads] = useState<CouponLead[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    request<CouponLeadsResponse>(
      `/api/admin/operations/coupons/${coupon.promoId}/leads`,
      { token },
    )
      .then((res) => {
        if (!cancelled) setLeads(res.items);
      })
      .catch((err) => {
        if (!cancelled) setError(describeError(err, "No se pudieron cargar los leads"));
      });
    return () => {
      cancelled = true;
    };
  }, [coupon.promoId, token]);

  return (
    <ModalShell
      title={`Leads del cupón · ${coupon.couponCode ?? coupon.name}`}
      onClose={onClose}
      width={640}
      footer={<GhostButton onClick={onClose}>Cerrar</GhostButton>}
    >
      {error && (
        <div style={{ color: "#b32424", fontSize: ".85rem" }}>{error}</div>
      )}
      {!error && leads === null && (
        <div style={{ color: "#73879C", fontSize: ".85rem" }}>Cargando…</div>
      )}
      {leads !== null && leads.length === 0 && (
        <div style={{ color: "#73879C", fontSize: ".85rem" }}>
          Ningún lead ha usado este cupón todavía.
        </div>
      )}
      {leads !== null && leads.length > 0 && (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: ".83rem" }}>
          <thead>
            <tr style={{ background: "#f8f9fb" }}>
              <Th>Lead</Th>
              <Th>Email</Th>
              <Th>Estado</Th>
              <Th>Creado</Th>
            </tr>
          </thead>
          <tbody>
            {leads.map((lead, i) => (
              <tr key={lead.ulid ?? i} style={{ borderTop: "1px solid #f1f3f5" }}>
                <Td>
                  {lead.ulid ? (
                    <Link to={`/leads/${lead.ulid}`} style={{ color: "#0069d9", fontWeight: 600 }}>
                      {lead.fullname || lead.ulid.slice(-10)}
                    </Link>
                  ) : (
                    lead.fullname || "—"
                  )}
                </Td>
                <Td>{lead.email ?? "—"}</Td>
                <Td>{lead.status ?? "—"}</Td>
                <Td>{fmtDate(lead.createdAt)}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </ModalShell>
  );
}

function Th({ children }: { children: React.ReactNode }) {
  return (
    <th
      style={{
        padding: "0.55rem 0.7rem",
        textAlign: "left",
        fontWeight: 600,
        color: "#1f2933",
        fontSize: ".72rem",
        textTransform: "uppercase",
        letterSpacing: ".3px",
      }}
    >
      {children}
    </th>
  );
}

function Td({ children }: { children: React.ReactNode }) {
  return (
    <td style={{ padding: "0.5rem 0.7rem", verticalAlign: "middle" }}>
      {children}
    </td>
  );
}
